"use client";

import { media } from "@/content/media";

/**
 * Services backdrop — single full-bleed splash (no Work collage / no tile grid).
 * One image keeps the parent `filter: blur` continuous and cheap; tiles of mixed
 * service cards looked wrong under blur and re-rasterized hard on reverse scroll.
 */
export function ServicesMosaic() {
  return (
    <div className="services_mosaic" id="services-mosaic" aria-hidden>
      <div className="services_mosaic_plane">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          className="services_mosaic_splash"
          src={media.services.splash}
          alt=""
          draggable={false}
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
      </div>
      <div className="services_mosaic_scrim" />
    </div>
  );
}
